import { useContext } from 'react';
import { IPageContext, PageContext } from 'context';

const usePage = (): IPageContext => useContext(PageContext);

export default usePage;
